import { makeStyles, mergeClasses } from '@griffel/react';
export const responsiveContainerClassNames = {
    root: 'fui-charts-resp__root'
};
const useStyles = makeStyles({
    root: {
        width: '100%',
        height: '100%',
        '& [class*="chartWrapper"]': {
            width: '100%',
            // To prevent chart height from collapsing while resizing
            height: '100%'
        },
        '& svg': {
            // This overrides the pixel width and height of svg allowing it to resize properly within flexbox
            width: '100%',
            height: '100%'
        }
    }
});
export const useResponsiveContainerStyles_unstable = (props)=>{
    const baseStyles = useStyles();
    return {
        root: mergeClasses(responsiveContainerClassNames.root, baseStyles.root)
    };
};
